// extracted by mini-css-extract-plugin
export var base = "Form-module--base--64402";
export var formContainer = "Form-module--form-container--209fd";
export var inputError = "Form-module--inputError--00052";
export var loader = "Form-module--loader--ba5c9";
export var newsletterAdvert = "Form-module--newsletter-advert--b42e8";
export var puffInCenter = "Form-module--puff-in-center--60a71";
export var shake = "Form-module--shake--06c7a";
export var thanks = "Form-module--thanks--c793c";